module.exports = __webpack_public_path__ + "static/img/1-1.5c758f85.png";